module.exports = __webpack_public_path__ + "vrgroup.8689d1e66864717c7da3.worker.js"